import { render, staticRenderFns } from "./OnboardingSteps.vue?vue&type=template&id=56135bcc&"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js&"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSteps.vue?vue&type=style&index=0&id=56135bcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports